import { API_GATEWATY_ENDPOINT, API_GATEWAY_API_KEY } from "constants/base";

export const completeInvitingProcess = async (
  username: string,
  newPassword: string,
): Promise<Boolean> => {
  const response = await fetch(`${API_GATEWATY_ENDPOINT}completeInvitingProcess`, {
    mode: "cors",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": API_GATEWAY_API_KEY
    },
    body: JSON.stringify({ username: username, newPassword: newPassword }),
  });
  const res = await response.json();
  return res as Boolean;
}
